import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  Link,
} from '@chakra-ui/react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      bg={'primary.500'}
      color={'whiteAlpha.900'}
      borderTop={'3px'}
      borderStyle={'solid'}
      borderColor={'accent.500'}
    >
      <Container
        as={Stack}
        maxW={'container.xl'}
        py={4}
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'center', md: 'center' }}
      >
        <Text>© {currentYear} Aididactic. Todos los derechos reservados.</Text>
        <Stack direction={'row'} spacing={6}>
          <Link href={'#'} _hover={{ color: 'accent.300' }}>Política de privacidad</Link>
          <Link href={'#'} _hover={{ color: 'accent.300' }}>Términos de uso</Link>
          <Link href={'#'} _hover={{ color: 'accent.300' }}>Contacto</Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
